import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, IconButton, MenuItem, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import Header from '../../../components/Header'
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
import { useFormik, useFormikContext } from 'formik';
import AddIcon from '@mui/icons-material/Add';
import { addDispatchProcess, deleteProcessDispatchDetails, editDispatchProcess, getAllDataForCommercialmarket, getDispatchProcess, getDispatchProcessForAddById, getProcesscategory, getProcesskitproduct, getProcessproduct, getProcesssubcategory, getprocessSuggestion, getProcesswarehouse } from '../../../redux/slice/dispatchProcess.slice';
import DeleteIcon from '@mui/icons-material/Delete';
import { format } from 'date-fns';
import PrintIcon from '@mui/icons-material/Print';
import { getPurchase } from '../../../redux/slice/Purchase.slice';
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake/build/pdfmake";
import LexendBold from "../../../fonts/Lexend-Bold.ttf";
import LexendRegular from "../../../fonts/Lexend-Regular.ttf";
import QtyInput from './QtyInput';
pdfMake.vfs = pdfFonts.pdfMake.vfs; // Use default vfs as a base

const getLexendFonts = async () => {
    const fetchFont = async (fontPath) => {
        const response = await fetch(fontPath);
        const buffer = await response.arrayBuffer();
        return bufferToBase64(buffer);
    };

    const regularFont = await fetchFont(LexendRegular);
    const boldFont = await fetchFont(LexendBold);

    pdfMake.vfs['Lexend-Regular.ttf'] = regularFont;
    pdfMake.vfs['Lexend-Bold.ttf'] = boldFont;

    pdfMake.fonts = {
        Lexend: {
            normal: 'Lexend-Regular.ttf',
            bold: 'Lexend-Bold.ttf',
        },
    };
};

const bufferToBase64 = (buffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
};

const getBase64Image = (img) => {
    return new Promise((resolve) => {
        const canvas = document.createElement("canvas");
        const image = new Image();
        image.crossOrigin = "anonymous";
        image.onload = () => {
            canvas.width = image.width;
            canvas.height = image.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0);
            const dataURL = canvas.toDataURL("image/png");
            resolve(dataURL);
        };
        image.src = img;
    });
};

const AddDispatchProcess = () => {
    const { state } = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const theme = useTheme();
    const [mid, setMid] = useState(state?.marketdata?._id || '');
    const [id, setId] = useState(state?.dispatchProcessId || '');
    const suggestiondata = useSelector(state => state.dispatchProcess.suggestion)
    const isNonMobile = useMediaQuery("(min-width:600px)");
    const [isSuggestionSelected, setIsSuggestionSelected] = React.useState(false);
    const kitproductdata = useSelector(state => state.dispatchProcess.kitproduct)
    const categories = useSelector(state => state.dispatchProcess.category)
    const subcategories = useSelector(state => state.dispatchProcess.subCategory)
    const products = useSelector(state => state.dispatchProcess.products)
    const AlldispatchProcess = useSelector(state => state.dispatchProcess.dispatchProcess)?.find(process => process.marketId == mid);
    const Market = useSelector(state => state.dispatchProcess.commercialMarket)?.find(m => m._id == mid)
    const getuserId = localStorage.getItem("id");



    useEffect(() => {
        getLexendFonts();
    }, []);


    console.log("AlldispatchProcess", Market, AlldispatchProcess);






    const [processData, setProcessData] = useState([]);
    const [dispatchDetails, setDispatchDetails] = useState([]);
    const warehousedata = useSelector(state => state.dispatchProcess.warehouse)
    const [selectedDispatchSuggestions, setSelectedDispatchSuggestions] = useState([]);
    const [selectedKit, setSelectedKit] = useState([]);
    const [pv1, setPv1] = useState(true)
    const [iv1, setIv1] = useState(true)
    const pv = Market?.productData?.[0]?._id
    const iv = Market?.inverterData?.[0]?._id

    const storeData = useSelector((state) => state.dispatchProcess.store)?.filter(v => v.warehouseId === Market?.wareHouseData[0]?._id);





    useEffect(() => {
        AlldispatchProcess?.ProcessData.forEach(v => {
            if ((v.DispatchDetails.some(d => d.DispatchProductName == pv))) {
                setPv1(false)
            }
            if ((v.DispatchDetails.some(d => d.DispatchProductName == iv))) {
                setIv1(false)
            }
        })
    }, [AlldispatchProcess])

    useEffect(() => {
        dispatch(getProcesscategory())
        dispatch(getProcesssubcategory())
        dispatch(getProcessproduct())
        dispatch(getProcesswarehouse())
        dispatch(getProcesskitproduct())
        dispatch(getprocessSuggestion())
        dispatch(getAllDataForCommercialmarket())
    }, [dispatch])


    useEffect(() => {
        if (mid) {
            dispatch(getDispatchProcessForAddById(mid));
        }

    }, [mid, id]);

    useEffect(() => {
        if (Market && !AlldispatchProcess) {
            const ProcessData1 = [{
                DispatchText: '',
                PurposeofDispatch: 'Customer Material',
                DispatchDate: '',
                DispatchSuggestionId: '',
                DispatchDetails: [
                    {
                        DispatchCatogory: Market.productData?.[0].mainCategory,
                        DispatchSubCatogory: Market.productData?.[0].subCategory,
                        DispatchProductName: Market.productData?.[0]._id,
                        DispatchKitId: '',
                        DispatchDiscription: Market.productData?.[0].Desacription,
                        DispatchUnit: Market.productData?.[0].unitOfMeasurement,
                        DispatchQty: '',
                    },
                    {
                        DispatchCatogory: Market.inverterData?.[0].mainCategory,
                        DispatchSubCatogory: Market.inverterData?.[0].subCategory,
                        DispatchProductName: Market.inverterData?.[0]._id,
                        DispatchKitId: '',
                        DispatchDiscription: Market.inverterData?.[0].Desacription,
                        DispatchUnit: Market.inverterData?.[0].unitOfMeasurement,
                        DispatchQty: '',
                    }
                ],
                DebitCreditWarehouseName: Market?.wareHouseData[0]?._id,
                DispatchModelTransport: '',
                DispatchRemarks: '',
            }]

            if (!AlldispatchProcess) {
                setValues({ ...values, ProcessData: ProcessData1 });
                setProcessData(ProcessData1);
            }
        }

    }, [Market, AlldispatchProcess]);

    useEffect(() => {
        if (id && AlldispatchProcess) {

            const ProcessData1 = [{
                DispatchText: '',
                PurposeofDispatch: 'Customer Material',
                DispatchDate: '',
                DispatchSuggestionId: '',
                DispatchDetails: [
                    {
                        DispatchCatogory: Market?.productData?.[0]?.mainCategory,
                        DispatchSubCatogory: Market?.productData?.[0]?.subCategory,
                        DispatchProductName: Market?.productData?.[0]?._id,
                        DispatchKitId: '',
                        DispatchDiscription: Market?.productData?.[0]?.Desacription,
                        DispatchUnit: Market?.productData?.[0]?.unitOfMeasurement,
                        DispatchQty: '',
                    },
                    {
                        DispatchCatogory: Market?.inverterData?.[0]?.mainCategory,
                        DispatchSubCatogory: Market?.inverterData?.[0]?.subCategory,
                        DispatchProductName: Market?.inverterData?.[0]?._id,
                        DispatchKitId: '',
                        DispatchDiscription: Market?.inverterData?.[0]?.Desacription,
                        DispatchUnit: Market?.inverterData?.[0]?.unitOfMeasurement,
                        DispatchQty: '',
                    }
                ],
                DebitCreditWarehouseName: Market?.wareHouseData[0]?._id,
                DispatchModelTransport: '',
                DispatchRemarks: '',
            }]

            let pv1 = true
            let iv1 = true
            const pv = Market?.productData?.[0]?._id
            const iv = Market?.inverterData?.[0]?._id

            AlldispatchProcess?.ProcessData.forEach(v => {
                if ((v.DispatchDetails.some(d => d.DispatchProductName == pv))) {
                    pv1 = false
                }
                if ((v.DispatchDetails.some(d => d.DispatchProductName == iv))) {
                    iv1 = false
                }
            })

            const dataaa = {
                ...AlldispatchProcess,
                ProcessData: [...AlldispatchProcess.ProcessData]
            };

            if (pv1 && iv1) {
                dataaa.ProcessData = dataaa.ProcessData.concat(ProcessData1);
            }
            setValues(dataaa);
            setProcessData(dataaa.ProcessData)
        }
    }, [id, AlldispatchProcess]);




    const handleSubmit = async () => {
        if (!mid) {
            alert("Market ID is not defined.");
            return;
        }




        try {






            //User entered data
            // const ee = values?.find(v => v?.marketId == mid);

            //dispatched data
            // const dd = AlldispatchProcess?.find(v => v?.marketId == mid);

            let dispatchedQty = 0;
            AlldispatchProcess?.ProcessData?.forEach((v) => {
                if (v?.PurposeofDispatch === 'Customer Material') {
                    const x = v.DispatchDetails?.find(vc => vc?.DispatchCatogory === "6749c8c7864db29472435057");


                    if (x) {
                        dispatchedQty += parseInt(x?.DispatchQty || 0);
                    }
                }
            });

            let enteredQty = 0;
            values?.ProcessData?.forEach((v) => {
                if (v?.PurposeofDispatch === 'Customer Material') {
                    const x = v.DispatchDetails?.find(vc => vc?.DispatchCatogory === "6749c8c7864db29472435057");


                    if (x) {
                        enteredQty += parseInt(x?.DispatchQty || 0);
                    }
                }
            });





            if (parseInt(Market?.SolarModuleNos) < parseInt(enteredQty)) {
                alert("Solar PV Dispatch Quantity exceed for " + Market?.fillNo);
                return;
            }

            let enteredQtyInv = 0;

            values?.ProcessData?.forEach((v) => {
                if (v?.PurposeofDispatch === 'Customer Material') {
                    const x = v.DispatchDetails?.find(vc => vc?.DispatchCatogory === "6749c8bf864db29472435052");




                    if (x) {
                        enteredQtyInv += parseInt(x?.DispatchQty || 0);
                    }
                }
            });

            if (enteredQtyInv > 1 && Market?.MarketingType === "Residential") {
                alert("Solar Inverter Quantity must be 1 for " + Market?.fillNo);
                return;
            }


            await validationSchemas.validate(values, { abortEarly: false });



            // ✅ All validations passed
            // alert("Validation successful!");
        } catch (err) {
            if (err.inner && err.inner.length > 0) {
                const errorMessages = err.inner.map(e => e.message).join('\n');
                alert("Please fill all required fields:\n" + errorMessages);
            } else {
                alert("Validation failed: " + err.message);
            }

            return;
        }


















        const uniqueData = values.ProcessData.map((v) => {
            if (!v?.generatedNumber) {
                let kitCounter = 1; // Counter to assign Kit numbers
                let flatDispatchDetails = v.DispatchDetails.flatMap((detail) => {
                    let x = kitproductdata.find((kp) => kp._id === detail.DispatchProductName);

                    if (x) {
                        const currentKitNo = kitCounter++; // Increment the Kit number for each Kit
                        return x.KitDetails.map((kit) => ({
                            DispatchKitId: x._id,
                            DispatchCatogory: kit.KitCatogory,
                            DispatchSubCatogory: kit.KitSubCatogory,
                            DispatchProductName: kit.KitProductName,
                            DispatchDiscription: kit.KitDiscription,
                            DispatchUnit: kit.KitUnit,
                            DispatchQty: kit.KitQty,
                            KitNo: currentKitNo // Add KitNo to each item in the current kit
                        }));
                    } else if (detail.DispatchKitDetails) {
                        const currentKitNo = kitCounter++; // Increment the Kit number for each Kit
                        return detail.DispatchKitDetails.map((kit) => ({
                            DispatchKitId: v.DispatchProductName,
                            DispatchCatogory: kit.KitCatogory,
                            DispatchSubCatogory: kit.KitSubCatogory,
                            DispatchProductName: kit.KitProductName,
                            DispatchDiscription: kit.KitDiscription,
                            DispatchUnit: kit.KitUnit,
                            DispatchQty: kit.KitQty,
                            KitNo: currentKitNo // Add KitNo to each item in the current kit
                        }));
                    } else if (!detail.DispatchKitId) {

                        return detail;
                    } else {
                        return detail;
                    }
                });

                return {
                    ...v,
                    DispatchDetails: flatDispatchDetails
                };
            } else {
                return v;
            }
        });

        const submissionValues = {
            ...values,
            marketId: mid,
            dispatchBy: getuserId,
            PendingPayment: (() => {
                if (!Market?.AccountData || Market?.AccountData.length === 0) {
                    return 'No Account Data Available';
                }

                const accountDetails = Market.AccountData[0]?.AccountDetails || [];
                const totalAccountAmount = accountDetails.reduce(
                    (sum, account) => sum + parseFloat(account.AccountAmount || 0),
                    0
                );

                const remainingAmount = parseFloat(Market.TotalAmount || 0) - totalAccountAmount;

                return remainingAmount > 0 ? `${remainingAmount}` : 'Fully Paid';
            })(),
            ProcessData: uniqueData.map((process, index) => {
                const processData = {
                    ...process
                };

                if (process.DispatchSuggestionId) {
                    processData.DispatchSuggestionId = process.DispatchSuggestionId;
                } else {
                    processData.DispatchSuggestionId = null;
                }

                return processData;
            }),
        };



        const process = submissionValues.ProcessData.map(process => ({
            ...process,
            DispatchDetails: process.DispatchDetails.filter(detail => detail.DispatchProductName != '')
        }));



        submissionValues.ProcessData = process;
        const newProcessData = submissionValues.ProcessData.splice(0, AlldispatchProcess?.ProcessData?.length);


        let res;

        if (id) {
            delete submissionValues.isActive;
            delete submissionValues.createdAt;
            delete submissionValues.updatedAt;






            res = await dispatch(editDispatchProcess({ _id: id, ...submissionValues }));
        } else {




            res = await dispatch(addDispatchProcess({ data: submissionValues }));
        }
        resetForm();
        handleClose();




        if (res.type == "dispatchProcess/add/fulfilled" || res.type == "dispatchProcess/edit") {
            navigate('/admin/dispatch-process');
        }

    };

    const validationSchemas = Yup.object({
        ProcessData: Yup.array().of(
            Yup.object({
                DispatchDate: Yup.string().required('Dispatch Date is required'),
                PurposeofDispatch: Yup.string().required("Please enter Purpose of Dispatch"),
                DispatchDetails: Yup.array().of(
                    Yup.object({
                        DispatchCatogory: Yup.string().required('Dispatch Category is required'),
                        DispatchSubCatogory: Yup.string().required('Dispatch Sub Category is required'),
                        DispatchProductName: Yup.string().test('required', 'Dispatch Product Name is required', function (value) {
                            const { parent } = this;
                            return parent.DispatchKitId ? true : !!value;
                        }),
                        DispatchQty: Yup.mixed().test(
                            'required-and-valid',
                            'Dispatch Quantity is required and must be a positive number',
                            function (value) {
                                const { parent } = this;
                                if (parent.DispatchKitId) return true;
                                const numberValue = Number(value);
                                return Number.isInteger(numberValue) && numberValue > 0;
                            }
                        ),
                    })
                ).required('Dispatch Details are required'),
                DebitCreditWarehouseName: Yup.string().required('Debit/Credit Warehouse Name is required'),
                DispatchModelTransport: Yup.string().required('Mode of Transport is required'),
                DispatchRemarks: Yup.string().required('Remarks are required'),
            })
        ).required('Process Data is required'),
    });

    const [processedData, setProcessedData] = useState([]);


    const processAllDispatchDetails = (d) => {
        const data = d?.find(v => v.generatedNumber === genNo)

        if (data) {
            const generatedNumber = data.generatedNumber;
            const dispatchDetails = data.DispatchDetails;
            const debitCreditWarehouseData = data.DebitCreditWarehouseData;

            const processedDispatchDetails = [];
            const seenKitNos = new Set(); // Keep track of seen KitNo values

            dispatchDetails.forEach(detail => {
                if (detail.DispatchKitId && seenKitNos.has(detail.KitNo)) {
                    return; // Skip if KitNo already seen
                }

                if (detail.DispatchKitId) {
                    seenKitNos.add(detail.KitNo);
                }

                const processedDetail = {
                    ...detail,
                    generatedNumber,
                    DebitCreditWarehouseData: debitCreditWarehouseData
                };

                if (detail.DispatchKitData) {
                    processedDetail.KitData = detail.DispatchKitData;
                }

                processedDispatchDetails.push(processedDetail);

            });

            return [{
                generatedNumber,
                PurposeofDispatch: data.PurposeofDispatch,
                DispatchSuggestionId: data.DispatchSuggestionId,
                DispatchDate: data.DispatchDate,
                DebitCreditWarehouseName: data.DebitCreditWarehouseName,
                DebitCreditWarehouseData: data.DebitCreditWarehouseData,
                DispatchModelTransport: data.DispatchModelTransport,
                DispatchRemarks: data.DispatchRemarks,
                createProcessDate: data.createProcessDate,
                DispatchDetails: processedDispatchDetails
            }];
        }
    }

    const initialValues = {
        marketId: mid,
        PendingPayment: '',
        ProcessData: [{
            DispatchText: '',
            PurposeofDispatch: 'Customer Material',
            DispatchDate: '',
            DispatchSuggestionId: '',
            DispatchDetails: [{
                DispatchCatogory: '',
                DispatchSubCatogory: '',
                DispatchProductName: '',
                DispatchKitId: '',
                DispatchKitDetails: [],
                DispatchDiscription: '',
                DispatchUnit: '',
                DispatchQty: '',
            }],
            DebitCreditWarehouseName: Market?.wareHouseData[0]?._id,
            DispatchModelTransport: '',
            DispatchRemarks: '',
        }],
    };

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchemas,
        onSubmit: handleSubmit
    });


    const getAvailableQty = (selectedWarehouse, selectedProduct) => {
        const productData = storeData?.flatMap(v => {
            return v?.multipleQty?.filter(qty => qty?.productName === selectedProduct);
        });





        const avlQty = productData?.reduce((acc, v) => acc + v.recieveQty, 0)

        return avlQty;
        // const matchingPurchases = purchase?.filter(purchase =>
        //     purchase.purchaseDetails?.some(pd =>
        //         pd.warehouseId === selectedWarehouse &&
        //         pd.multipleQty?.some(item => item.productName === selectedProduct)
        //     )
        // );


        // const totalQty = matchingPurchases.reduce((sum, purchase) => {
        //     const totalFromDetails = purchase.purchaseDetails?.reduce((detailSum, detail) => {
        //         if (detail.warehouseId === selectedWarehouse) {
        //             const productItems = detail.multipleQty.filter(item =>
        //                 item.productName === selectedProduct
        //             );


        //             return detailSum + productItems.reduce((itemSum, item) =>
        //                 itemSum + (parseInt(item.recieveQty) || 0), 0
        //             );
        //         }

        //         return detailSum;
        //     }, 0) || 0;
        //     return sum + totalFromDetails;
        // }, 0);

        // return totalQty;
    };

    const { handleBlur, handleChange, values, touched, errors, setFieldValue, resetForm, setValues } = formik


    const insufficientProducts = useMemo(() => {
        const grouped = {};
        const requiredQtyMap = new Map();


        values?.ProcessData
            .filter(v => !v?.generatedNumber && v?.PurposeofDispatch === "Customer Material")
            .forEach((process) => {
                process?.DispatchDetails?.forEach((detail) => {
                    const productName = detail?.DispatchProductName;
                    const kit = kitproductdata?.find(k => k._id === productName);
                    if (kit) {
                        kit?.KitDetails?.forEach(kitItem => {
                            const name = kitItem?.KitProductName;
                            const qty = parseInt(kitItem?.KitQty);
                            requiredQtyMap.set(name, (requiredQtyMap?.get(name) || 0) + qty);
                        });
                    } else {
                        requiredQtyMap.set(productName, (requiredQtyMap?.get(productName) || 0) + Number(detail.DispatchQty));
                    }
                });
            });


        const insufficient = new Set();

        requiredQtyMap.forEach((requiredQty, productId) => {
            const available = getAvailableQty(Market?.WarehouseId, productId);
            if (requiredQty > available) {
                insufficient.add(productId);
            }
        });

        return insufficient;
    }, [values, Market, kitproductdata]);



    useEffect(() => {
        if (processData.length > 0) {
            setValues({ ...initialValues, ProcessData: processData });
        }
    }, [processData]);


    const handleDispatchSuggestion = (event, index) => {
        const { name, value } = event.target;

        setFieldValue(name, value);

        const selectedSuggestion = suggestiondata.find(suggestion => suggestion._id === value);

        if (selectedSuggestion) {
            let updatedDetails = [...(selectedSuggestion.DispatchDetails || [])]; // Create a shallow copy to avoid mutating the original





            updatedDetails.forEach(detail => {
                if (detail.DispatchCatogory === kitCategoryId &&
                    detail.DispatchSubCatogory === kitSubCategoryId) {


                    checkKitAvailability(detail.DispatchProductName);
                }
            });




            // Check and replace or add for 6749c8c7864db29472435057  //Solar PV Module
            const indexProduct = updatedDetails.map(detail =>
                detail.DispatchCatogory.trim() === "6749c8c7864db29472435057"
            );






            const isDisabledSolarPV = AlldispatchProcess?.ProcessData?.some((v) =>
                v?.DispatchDetails.some((v1) =>
                    (v1.DispatchCatogory === "6749c8c7864db29472435057")
                )
            );





            let sum = 0;

            AlldispatchProcess?.ProcessData?.map((v) => {

                if (v?.PurposeofDispatch === 'Customer Material') {
                    let x = v.DispatchDetails?.find(vc => vc?.DispatchCatogory === "6749c8c7864db29472435057");



                    if (x) {
                        sum = sum + parseInt(x?.DispatchQty)
                    }

                }
            })






            const iPV = updatedDetails.findIndex((v) => v.DispatchCatogory === Market?.productData[0]?.mainCategory);

            if ((iPV != -1) && isDisabledSolarPV && sum >= parseInt(Market?.SolarModuleNos)) {





                updatedDetails.splice(iPV, 1)


            } else {


                if (iPV !== -1) {
                    updatedDetails[iPV] = {
                        DispatchCatogory: Market.productData?.[0].mainCategory,
                        DispatchSubCatogory: Market.productData?.[0].subCategory,
                        DispatchProductName: Market.productData?.[0]._id,
                        DispatchKitId: '',
                        DispatchDiscription: Market.productData?.[0].Desacription,
                        DispatchUnit: Market.productData?.[0].unitOfMeasurement,
                        DispatchQty: Market.SolarModuleNos,
                    };
                } else if (indexProduct >= 0) {

                    updatedDetails[indexProduct] = {
                        DispatchCatogory: Market.productData?.[0].mainCategory,
                        DispatchSubCatogory: Market.productData?.[0].subCategory,
                        DispatchProductName: Market.productData?.[0]._id,
                        DispatchKitId: '',
                        DispatchDiscription: Market.productData?.[0].Desacription,
                        DispatchUnit: Market.productData?.[0].unitOfMeasurement,
                        DispatchQty: '',
                    };
                } else {


                    // updatedDetails.push({
                    //     DispatchCatogory: Market.productData?.[0].mainCategory,
                    //     DispatchSubCatogory: Market.productData?.[0].subCategory,
                    //     DispatchProductName: Market.productData?.[0]._id,
                    //     DispatchKitId: '',
                    //     DispatchDiscription: Market.productData?.[0].Desacription,
                    //     DispatchUnit: Market.productData?.[0].unitOfMeasurement,
                    //     DispatchQty: '',
                    // });
                }
            }

            // Check and replace or add for 6749c8bf864db29472435052 //Solar Grid Tie Inverter
            const indexInverter = updatedDetails.findIndex(detail => detail.DispatchCatogory === "6749c8bf864db29472435052");
            const isDisabledInverter = AlldispatchProcess?.ProcessData?.some((v) =>
                v?.DispatchDetails.some((v1) =>
                    (v1.DispatchCatogory === "6749c8bf864db29472435052")
                )
            );



            const iIN = updatedDetails.findIndex((v) => v.DispatchCatogory === Market?.inverterData[0]?.mainCategory);

            if ((iIN != -1) && isDisabledInverter) {


                updatedDetails.splice(iIN, 1)
            } else {
                if (indexInverter >= 0) {
                    updatedDetails[indexInverter] = {
                        DispatchCatogory: Market.inverterData?.[0].mainCategory,
                        DispatchSubCatogory: Market.inverterData?.[0].subCategory,
                        DispatchProductName: Market.inverterData?.[0]._id,
                        DispatchKitId: '',
                        DispatchDiscription: Market.inverterData?.[0].Desacription,
                        DispatchUnit: Market.inverterData?.[0].unitOfMeasurement,
                        DispatchQty: Market.MarketingType === 'Residential' ? 1 : '',
                    };
                } else {
                    // updatedDetails.push({
                    //     DispatchCatogory: Market.inverterData?.[0].mainCategory,
                    //     DispatchSubCatogory: Market.inverterData?.[0].subCategory,
                    //     DispatchProductName: Market.inverterData?.[0]._id,
                    //     DispatchKitId: '',
                    //     DispatchDiscription: Market.inverterData?.[0].Desacription,
                    //     DispatchUnit: Market.inverterData?.[0].unitOfMeasurement,
                    //     DispatchQty: '',
                    // });
                }
            }




            setDispatchDetails(prevDetails => {
                const newDetails = [...prevDetails];  // Create a copy of the previous state
                newDetails[index] = updatedDetails;
                return newDetails;
            });




            setFieldValue(`ProcessData[${index}].DispatchDetails`, updatedDetails);
        }

    };



    const handleAddDispatchDetail = (processIndex) => {
        const newDetail = {
            DispatchCatogory: '',
            DispatchSubCatogory: '',
            DispatchProductName: '',
            DispatchDiscription: '',
            DispatchUnit: '',
            DispatchQty: '',
        };

        setDispatchDetails(prevDetails => {

            const updatedDetails = [...prevDetails];
            if (!Array.isArray(updatedDetails[processIndex])) {
                updatedDetails[processIndex] = [];
            }
            updatedDetails[processIndex] = [...updatedDetails[processIndex], newDetail];
            return updatedDetails;
        });

        setFieldValue(`ProcessData[${processIndex}].DispatchDetails`,
            values.ProcessData[processIndex].DispatchDetails
                ? [...values.ProcessData[processIndex].DispatchDetails, newDetail]
                : [newDetail]
        );
    };

    const handleAddProcess = () => {
        const newProcess = {
            DispatchText: '',
            PurposeofDispatch: 'Customer Material',
            DispatchSuggestionId: '',
            DispatchModelTransport: '',
            DispatchRemarks: '',
            DispatchDate: '',
            DebitCreditWarehouseName: Market?.wareHouseData[0]?._id,
        };

        const updatedData = [...values?.ProcessData, newProcess];
        setFieldValue('ProcessData', updatedData);
    };

    const handleDispatchDetailChange = (i, field, value) => {


        setFieldValue(`ProcessData[${i}].${field}`, value);
        setDispatchDetails(prevDetails => {
            const newDetails = [...prevDetails];
            if (!newDetails[i]) {
                newDetails[i] = {};
            }
            newDetails[i] = { ...newDetails[i], [field]: value };
            return newDetails;
        });
    };

    const handleProcessChange = (index, field, value) => {
        const updatedProcesses = values.ProcessData.map((process, idx) => {
            if (idx === index) {
                return { ...process, [field]: value };
            }
            if (field === 'DebitCreditWarehouseName') {
                return { ...process, DebitCreditWarehouseName: value };
            }
            if (field === 'DispatchRemarks') {
                return { ...process, DispatchRemarks: value };
            }
            if (field === 'DispatchModelTransport') {
                return { ...process, DispatchModelTransport: value };
            }
            return process;
        });
        setFieldValue('ProcessData', updatedProcesses);
    };

    // const getFilteredSubcategories = (categoryId) => {
    //     const isDisabled =
    //         categoryId === Market?.productData?.[0]?.mainCategory ||
    //         categoryId === Market?.inverterData?.[0]?.mainCategory;




    //     return { data: subcategories?.filter(sub => sub.categoryData?.[0]?._id === categoryId), isDisabled };
    // };

    const getFilteredSubcategories = useCallback((categoryId) => {
        const isDisabled =
            categoryId === Market?.productData?.[0]?.mainCategory ||
            categoryId === Market?.inverterData?.[0]?.mainCategory;




        return { data: subcategories?.filter(sub => sub.categoryData?.[0]?._id === categoryId), isDisabled };
    }, [subcategories]);

    // const getFilteredProducts = (categoryId, subcategoryId) => {
    //     const isDisabled =
    //         categoryId === Market?.productData?.[0]?.mainCategory ||
    //         categoryId === Market?.inverterData?.[0]?.mainCategory;

    //     return {
    //         data: products?.filter(product =>
    //             product.mainCategoryData?.[0]?._id === categoryId && product.subCategoryData?.[0]?._id === subcategoryId
    //         ),
    //         isDisabled
    //     };
    // };

    const getFilteredProducts = useCallback((categoryId, subcategoryId) => {
        const isDisabled =
            categoryId === Market?.productData?.[0]?.mainCategory ||
            categoryId === Market?.inverterData?.[0]?.mainCategory;

        return {
            data: products?.filter(product =>
                product.mainCategoryData?.[0]?._id === categoryId && product.subCategoryData?.[0]?._id === subcategoryId
            ),
            isDisabled
        };
    }, [products]);

    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        setOpen(false);
    };
    const handleOpen = () => {
        setOpen(true);
    };
    const kitCategoryId = categories.find(cat => cat.categoryName === 'KitCategory')?._id;
    const kitSubCategoryId = subcategories.find(sub => sub.subCategoryName === 'KitSubCategory')?._id;


    const handleAddKit1 = (processIndex, detailIndex, index) => {
        const oldKitDetails = [...values.ProcessData[processIndex].DispatchDetails];
        const newKit = {
            DispatchCatogory: '',
            DispatchSubCatogory: '',
            DispatchProductName: '',
            DispatchDiscription: '',
            DispatchUnit: '',
            DispatchQty: '',
        };

        oldKitDetails.splice(detailIndex + 1, 0, newKit);
        setDispatchDetails(prevDetails => {
            const newDetails = [...prevDetails];
            newDetails[processIndex] = oldKitDetails;
            return newDetails;
        });
        setFieldValue(`ProcessData[${processIndex}].DispatchDetails`, oldKitDetails);
        formik.setTouched({
            ProcessData: oldKitDetails.map((_, i) => ({
                DispatchCatogory: i === index + 1 ? false : touched.ProcessData?.[i]?.DispatchCatogory,
                DispatchSubCatogory: i === index + 1 ? false : touched.ProcessData?.[i]?.DispatchSubCatogory,
                DispatchProductName: i === index + 1 ? false : touched.ProcessData?.[i]?.DispatchProductName,
                DispatchDiscription: i === index + 1 ? false : touched.ProcessData?.[i]?.DispatchDiscription,
                DispatchUnit: i === index + 1 ? false : touched.ProcessData?.[i]?.DispatchUnit,
                DispatchQty: i === index + 1 ? false : touched.ProcessData?.[i]?.DispatchQty,
            })),
        });
    };

    const handleDeleteKit = (processIndex, dispatchIndex) => {
        if (!values?.ProcessData?.[processIndex]?.DispatchDetails) {
            console.error('Invalid ProcessData or DispatchDetails');
            return;
        }

        const updatedDetails = [...values.ProcessData[processIndex].DispatchDetails];
        const kitDetail = updatedDetails[dispatchIndex];

        if (kitDetail?._id) {
            dispatch(deleteProcessDispatchDetails(kitDetail._id));
        }

        updatedDetails.splice(dispatchIndex, 1);
        setDispatchDetails(prevDetails => {
            const newDetails = [...prevDetails];
            newDetails[processIndex] = updatedDetails;
            return newDetails;
        });
        setFieldValue(`ProcessData[${processIndex}].DispatchDetails`, updatedDetails);
    };




    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteItemIndex, setDeleteItemIndex] = useState(null);

    const handleOpenDeleteDialog = (processIndex, dispatchIndex) => {
        setDeleteItemIndex({ processIndex, dispatchIndex });
        setOpenDeleteDialog(true);
    };

    const handleCloseDeleteDialog = () => {
        setOpenDeleteDialog(false);
        setDeleteItemIndex(null);
    };

    const handleDeleteConfirmed = () => {
        if (deleteItemIndex) {
            const { processIndex, dispatchIndex } = deleteItemIndex;
            if (!values?.ProcessData?.[processIndex]?.DispatchDetails) {
                console.error('Invalid ProcessData or DispatchDetails');
                return;
            }

            const updatedDetails = [...values.ProcessData[processIndex].DispatchDetails];
            const kitDetail = updatedDetails[dispatchIndex];

            // if (kitDetail?._id) {
            //     dispatch(deleteProcessDispatchDetails(kitDetail._id));
            // }

            updatedDetails.splice(dispatchIndex, 1);
            setDispatchDetails(prevDetails => {
                const newDetails = [...prevDetails];
                newDetails[processIndex] = updatedDetails;
                return newDetails;
            });
            setFieldValue(`ProcessData[${processIndex}].DispatchDetails`, updatedDetails);
        }

        handleCloseDeleteDialog();
    };

    const orderDetails = {
        billTo: {
            companyName: 'Tvarit Energy LLP.',
            address: '707 - Twin Star, North Block, Near Nana Mava Circle, 150 Ft Ring Road, Rajkot, Gujarat - 360005',
            gst: '24AAQFT9592E1ZK',
            contactNumber: '+91 97245 71843',
            email: 'info@tvaritenergy.in',
            website: 'www.tvaritenergy.in',
        },
    };

    const [openDialog, setOpenDialog] = useState(false);
    const [selectedprocess, setSelectedprocess] = useState(null);
    const [dispatchProcessId, setDispatchProcessId] = useState(null);
    const [kitAvaStatus, setKitAvaStatus] = useState('');
    const [genNo, setGenNo] = useState('');

    const printRef = useRef();

    const handlePrint = (AlldispatchProcess, process, i) => {
        console.log("AlldispatchProcess, process, i", AlldispatchProcess, process, i);


        setSelectedprocess(AlldispatchProcess);
        setGenNo(process.generatedNumber);
        setOpenDialog(true);
    };




    const handleCloseDialog = () => {
        setOpenDialog(false);
    };



    const checkKitAvailability = (kitId) => {


        let selectedWarehouse = Market?.wareHouseData[0]?._id;
        const kit = kitproductdata.find(kit => kit._id === kitId); // Find the specific kit by kitId

        if (!kit) {

            return { KitName: null, Status: "Kit not found" };
        }

        let isAvailable = true;

        for (let item of kit.KitDetails) {
            const availableQty = getAvailableQty(selectedWarehouse, item.KitProductName);




            if (availableQty < parseInt(item.KitQty)) {
                isAvailable = false;
                break;
            }
        }

        const status = {
            KitName: kit.KitName,
            Status: isAvailable ? "Available all" : "Some are not available"
        };





        setKitAvaStatus(status)
        // return status
    };

    const [kitIdS, setKitIdS] = useState('');

    useEffect(() => {
        if (kitIdS) {
            checkKitAvailability(kitIdS)
        }

    }, [dispatch])
    const generateProductRows = (processItem) => {


        if (!processItem?.DispatchDetails) return [];
        return processItem.DispatchDetails.map((item, DataIndex) => {
            // const product = item.DispatchProductNameData;
            const qty = item.DispatchQty || 0;

            const product = item?.KitNo === 0 ?
                item.DispatchProductNameData || 'N/A' :
                kitproductdata?.find((k) => k?._id === item.DispatchKitId)
                ;

            return [
                { text: (DataIndex + 1).toString(), fontSize: 9 },
                { text: product?.productName || product?.KitName || 'N/A', fontSize: 9 },
                { text: item?.KitNo === 0 ? item.DispatchDiscription || 'N/A' : 'N/A', fontSize: 9 },
                { text: item?.KitNo === 0 ? qty.toString() || 'N/A' : 1, fontSize: 9 },
            ];
        });
    };




    const generatePdfContent = async (selectedprocess, matchingDispatchProcess) => {


        pdfMake.vfs = pdfFonts.pdfMake.vfs;
        pdfMake.fonts = {
            Lexend: {
                normal: 'Lexend-Regular.ttf',
                bold: 'Lexend-Bold.ttf',
            }
        };

        const logoSrc = theme.palette.mode === "dark" ? '../../assets/images/logo/logo.svg' : '../../assets/images/logo/logo.svg';
        const logoBase64 = await getBase64Image(logoSrc);
        const stampImg = await getBase64Image("../../assets/images/stamp/stamp.svg")
        const allPagesContent = [];
        matchingDispatchProcess?.ProcessData?.forEach((processItem, index) => {
            if (index > 0) {
                allPagesContent.push({ text: '', pageBreak: 'before' });
            }

            allPagesContent.push(
                {
                    columns: [
                        {
                            image: logoBase64,
                            width: 100,
                            margin: [0, 0, 0, 0]
                        },
                        {
                            text: matchingDispatchProcess?.ProcessData?.[index]?.generatedNumber.includes('Return') ? 'RETURN CHALLAN' : 'DISPATCH CHALLAN',
                            style: 'header',
                            alignment: 'right',
                            margin: [0, 0, 0, 2],
                            decoration: 'underline',
                            decorationColor: '#FB9822',
                            fontSize: 16,
                            characterSpacing: 2
                        },

                    ],
                },

                {
                    table: {
                        widths: ['50%'],
                        body: [
                            []
                        ]
                    },
                    margin: [0, 20, 0, 0]
                },
                {

                    columns: [
                        {
                            width: '48%',
                            table: {
                                widths: ['100%'],
                                body: [
                                    [{
                                        fillColor: '#1A2B4F',
                                        color: '#FFFFFF',
                                        text: 'CUSTOMER DETAILS',
                                        bold: true,
                                        fontSize: 11,
                                        margin: [5, 5],
                                        characterSpacing: 2
                                    }]
                                ]
                            }
                        },

                        { width: '4%', text: '' },
                        {
                            width: '48%',
                            table: {
                                widths: ['32%', '2%', '66%'],
                                body: [
                                    [
                                        { text: 'Dispatch No', bold: true, fontSize: 9, border: [false, false, false, false] },
                                        { text: ':', border: [false, false, false, false], fontSize: 9 },
                                        { text: matchingDispatchProcess?.ProcessData?.[index]?.generatedNumber || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                    ],
                                    [
                                        { text: 'Date', bold: true, fontSize: 9, border: [false, false, false, false] },
                                        { text: ':', border: [false, false, false, false], fontSize: 9 },
                                        { text: format(new Date(matchingDispatchProcess?.ProcessData?.[index]?.DispatchDate), 'dd-MM-yyyy') || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                    ]
                                ]
                            },
                            layout: {
                                hLineWidth: function (i, node) {
                                    return (i === 0 || i === node.table.body.length) ? 0 : 0;
                                },
                                vLineWidth: function (i, node) {
                                    return 0;
                                },
                            }
                        }
                    ],
                    margin: [0, 20, 0, 20]
                },
                {
                    columns: [
                        {
                            width: '48%',
                            table: {
                                widths: ['42%', '2%', '56%'], // Changed widths
                                body: [
                                    [
                                        { text: 'Customer Name', border: [false, false, false, false], fontSize: 9 },
                                        { text: ':', border: [false, false, false, false], fontSize: 9 },
                                        { text: selectedprocess?.marketData?.ConsumerName + ' (' + selectedprocess?.marketData?.fillNo + ')' || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                    ],
                                    [
                                        { text: 'Customer Address', border: [false, false, false, false], fontSize: 9 },
                                        { text: ':', border: [false, false, false, false], fontSize: 9 },
                                        { text: selectedprocess?.marketData?.Address || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                    ],
                                    [
                                        { text: 'Customer Mobile No', border: [false, false, false, false], fontSize: 9 },
                                        { text: ':', border: [false, false, false, false], fontSize: 9 },
                                        { text: selectedprocess?.marketData?.PhoneNumber || 'N/A', fontSize: 9, border: [false, false, false, false] }
                                    ]
                                ]
                            },
                            layout: {
                                hLineWidth: function (i, node) {
                                    return (i === 0 || i === node.table.body.length) ? 0 : 0;
                                },
                                vLineWidth: function (i, node) {
                                    return 0;
                                },
                            }
                        }
                    ]
                },
                {
                    columns: [
                        {
                            width: '48%',
                            table: {
                                widths: ['100%'],
                                body: [
                                    [{
                                        fillColor: '#1A2B4F',
                                        color: '#FFFFFF',
                                        text: 'TVARIT ADDRESS',
                                        bold: true,
                                        fontSize: 11,
                                        margin: [5, 5],
                                        characterSpacing: 2
                                    }]
                                ]
                            }
                        },
                        { width: '4%', text: '' },
                        {
                            width: '48%',
                            table: {
                                widths: ['100%'],
                                body: [
                                    [{
                                        fillColor: '#1A2B4F',
                                        color: '#FFFFFF',
                                        text: 'SHIP FROM',
                                        bold: true,
                                        fontSize: 11,
                                        margin: [5, 5],
                                        characterSpacing: 2
                                    }]
                                ]
                            }
                        }
                    ],
                    margin: [0, 20, 0, 20]
                },

                {
                    columns: [
                        {
                            width: '48%',
                            stack: [
                                {
                                    table: {
                                        widths: ['42%', '2%', '56%'],
                                        body: [
                                            [
                                                { text: 'Company Name', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                { text: orderDetails.billTo.companyName, border: [false, false, false, false], fontSize: 9 }
                                            ],
                                            [
                                                { text: 'Address', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                { text: orderDetails.billTo.address, border: [false, false, false, false], fontSize: 9 }
                                            ],
                                            [
                                                { text: 'GST No', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                { text: orderDetails.billTo.gst, border: [false, false, false, false], fontSize: 9 }
                                            ],
                                            [
                                                { text: 'Contact No', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                { text: orderDetails.billTo.contactNumber, border: [false, false, false, false], fontSize: 9 }
                                            ],
                                            [
                                                { text: 'Email', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                { text: orderDetails.billTo.email, border: [false, false, false, false], fontSize: 9 }
                                            ],
                                            [
                                                { text: 'Website', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                { text: orderDetails.billTo.website, border: [false, false, false, false], fontSize: 9 }
                                            ]
                                        ]
                                    },
                                    layout: {
                                        defaultBorder: false,
                                        paddingLeft: function (i) { return 4; },
                                        paddingRight: function (i) { return 4; },
                                        paddingTop: function (i) { return 4; },
                                        paddingBottom: function (i) { return 4; }
                                    }
                                }
                            ]
                        },
                        { width: '4%', text: '' },
                        {
                            width: '48%',
                            stack: [
                                {
                                    table: {
                                        widths: ['42%', '2%', '56%'],
                                        body: [
                                            [
                                                { text: 'Company Name', border: [false, false, false, false], fontSize: 9 },
                                                { text: ':', border: [false, false, false, false], fontSize: 9 },
                                                {
                                                    text: (() => {
                                                        if (!matchingDispatchProcess?.ProcessData?.[index]) return 'N/A';
                                                        const warehouseName = matchingDispatchProcess.ProcessData[index]?.DebitCreditWarehouseData?.wareHouseName || 'N/A';
                                                        return warehouseName || 'N/A';
                                                    })(), border: [false, false, false, false], fontSize: 9, alignment: 'start'
                                                }

                                            ]
                                        ]
                                    },
                                    layout: {
                                        defaultBorder: false,
                                        paddingLeft: function (i) { return 4; },
                                        paddingRight: function (i) { return 4; },
                                        paddingTop: function (i) { return 4; },
                                        paddingBottom: function (i) { return 4; }
                                    }
                                }
                            ]
                        }
                    ]
                },

                {
                    table: {
                        headerRows: 1,
                        widths: ['auto', '*', '*', 'auto'],
                        body: [
                            [
                                { text: 'SR. NO.', style: 'tableHeader', border: [true, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                                { text: 'PRODUCT NAME', style: 'tableHeader', border: [false, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                                { text: 'DESCRIPTION', style: 'tableHeader', border: [false, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                                { text: 'QTY.', style: 'tableHeader', border: [false, true, false, true], margin: [0, 3], fontSize: 8, characterSpacing: 1 }, // Reduced margin and font size
                            ],
                            ...generateProductRows(processItem)
                        ]
                    },
                    margin: [0, 10, 0, 0] // Reduced table margin
                },
                {
                    width: '*',
                    stack: [
                        {
                            image: stampImg,
                            width: 150,
                            alignment: 'right'
                        },
                        {
                            text: 'Company Stamp & Sign',
                            alignment: 'right',
                            bold: true,
                            margin: [0, 5, 0, 0]
                        }
                    ],
                    margin: [0, 20, 0, 0] // Reduced stamp margin
                }
            );
        });

        // Check for bulk data
        // const processbulkIds = AlldispatchProcess.find(process => process._id === dispatchProcessId);
        // const bulkIds = processbulkIds?.ProcessData.map(p => p.bulkId).filter(Boolean);
        // const bulkfiltered = AlldispatchProcess.filter(process =>
        //     process.ProcessData.some(data => bulkIds?.includes(data.bulkId))
        // );

        // if (bulkIds) {
        //     if (bulkfiltered.length > 0) {
        //         allPagesContent.push({ text: '', pageBreak: 'before' });

        //         allPagesContent.push({
        //             text: 'Bulk Dispatch Details',
        //             style: 'header',
        //             margin: [0, 20, 0, 10]
        //         });
        //         allPagesContent.push(
        //             {
        //                 columns: [
        //                     {
        //                         image: logoBase64,
        //                         width: 100,
        //                         margin: [0, 0, 0, 0]
        //                     },
        //                     // {
        //                     //     text: matchingDispatchProcess?.ProcessData?.[0]?.generatedNumber.includes('Return') ? 'RETURN CHALLAN' : 'DISPATCH CHALLAN',
        //                     //     style: 'header',
        //                     //     alignment: 'right',
        //                     //     margin: [0, 0, 0, 2],
        //                     //     decoration: 'underline',
        //                     //     decorationColor: '#FB9822'
        //                     // },
        //                 ],
        //             },
        //             {
        //                 table: {
        //                     widths: ['50%'],
        //                     body: [
        //                         [{
        //                             fillColor: '#1A2B4F',
        //                             color: '#FFFFFF',
        //                             text: 'CUSTOMER ADDRESS',
        //                             bold: true,
        //                             fontSize: 11,
        //                             margin: [5, 5]
        //                         }]
        //                     ]
        //                 },
        //                 margin: [0, 20, 0, 0]
        //             },
        //             {
        //                 columns: [
        //                     {
        //                         width: '50%',
        //                         text: [
        //                             { text: 'Customer Address : ', bold: true },
        //                             selectedprocess?.Address || 'N/A'
        //                         ]
        //                     },
        //                     {
        //                         width: '50%',
        //                         stack: [
        //                             {
        //                                 text: [
        //                                     { text: 'Date : ', bold: true, fontSize: 11 },
        //                                     { text: format(new Date(), 'dd-MM-yyyy'), fontSize: 11 }
        //                                 ],
        //                                 margin: [0, 0, 0, 5]
        //                             },
        //                             // {
        //                             //     text: [
        //                             //         { text: 'Dispatch Number : ', bold: true, fontSize: 11 },
        //                             //         { text: matchingDispatchProcess?.ProcessData?.[0]?.generatedNumber || 'N/A', fontSize: 11 }
        //                             //     ]
        //                             // }
        //                         ]
        //                     }
        //                 ],
        //                 margin: [5, 10]
        //             },
        //             {
        //                 table: {
        //                     widths: ['50%', '50%'],
        //                     body: [
        //                         [
        //                             {
        //                                 fillColor: '#1A2B4F',
        //                                 color: '#FFFFFF',
        //                                 text: 'TVARIT ADDRESS',
        //                                 bold: true,
        //                                 fontSize: 12,
        //                                 margin: [5, 5]
        //                             },
        //                             {
        //                                 fillColor: '#1A2B4F',
        //                                 color: '#FFFFFF',
        //                                 text: 'SHIP FROM',
        //                                 bold: true,
        //                                 fontSize: 12,
        //                                 margin: [5, 5]
        //                             }
        //                         ]
        //                     ]
        //                 },
        //                 margin: [0, 20, 0, 20]
        //             },
        //             {
        //                 columns: [
        //                     {
        //                         width: '48%',
        //                         stack: [
        //                             {
        //                                 table: {
        //                                     widths: ['45%', '55%'],
        //                                     body: [
        //                                         [
        //                                             { text: 'Company Name :', fontSize: 11 },
        //                                             { text: orderDetails.billTo.companyName, fontSize: 11 }
        //                                         ],
        //                                         [
        //                                             { text: 'Address :', fontSize: 11 },
        //                                             { text: orderDetails.billTo.address, fontSize: 11 }
        //                                         ],
        //                                         [
        //                                             { text: 'GST No:', fontSize: 11 },
        //                                             { text: '24AAQFT9592E1ZK', fontSize: 11 }
        //                                         ],
        //                                         [
        //                                             { text: 'Contact No :', fontSize: 11 },
        //                                             { text: '+91 97245 71843', fontSize: 11 }
        //                                         ],
        //                                         [
        //                                             { text: 'Email :', fontSize: 11 },
        //                                             { text: 'info@tvaritenergy.in', fontSize: 11 }
        //                                         ],
        //                                         [
        //                                             { text: 'Website :', fontSize: 11, margin: [0, 0, 10, 0] },
        //                                             { text: 'www.tvaritenergy.in', fontSize: 11, margin: [0, 0, 10, 0] }
        //                                         ]
        //                                     ]
        //                                 },
        //                                 layout: 'noBorders',

        //                             }
        //                         ]
        //                     },
        //                     {
        //                         width: '48%',
        //                         stack: [
        //                             {
        //                                 table: {
        //                                     widths: ['40%', '60%'],
        //                                     body: [
        //                                         [
        //                                             { text: 'Company Name :', fontSize: 11 },
        //                                             {
        //                                                 text: (() => {
        //                                                     const ProcessWarehouse = AlldispatchProcess.find(process => process.marketId === selectedprocess?._id);
        //                                                     if (!ProcessWarehouse?.ProcessData?.[0]) return 'N/A';
        //                                                     const warehouseName = ProcessWarehouse.ProcessData[0]?.DebitCreditWarehouseData?.wareHouseName || 'N/A';
        //                                                     return warehouseName;
        //                                                 })(),
        //                                                 fontSize: 11
        //                                             }
        //                                         ]
        //                                     ]
        //                                 },
        //                                 layout: 'noBorders'
        //                             }
        //                         ]
        //                     }
        //                 ]
        //             }
        //         );
        //         {
        //             bulkfiltered?.length > 0 ? (
        //                 bulkfiltered?.map((bulkItem, bulkIndex) => {
        //                     const matchingProcessData = bulkItem.ProcessData.filter(processData =>
        //                         bulkIds.includes(processData.bulkId) && processData.bulkId
        //                     );

        //                     return (
        //                         <Box key={bulkIndex} sx={{ padding: 2 }}>
        //                             {matchingProcessData.map((processData, processIndex) => {
        //                                 allPagesContent.push({
        //                                     text: `Details for ${processData.generatedNumber}`,
        //                                     style: 'subheader',
        //                                     margin: [0, 20, 0, 0],
        //                                     fontSize: 11
        //                                 });
        //                                 allPagesContent.push({
        //                                     table: {
        //                                         headerRows: 1,
        //                                         widths: ['auto', '*', '*', 'auto', 'auto'],
        //                                         body: [
        //                                             [
        //                                                 { text: 'SR. NO.', style: 'tableHeader' },
        //                                                 { text: 'PRODUCT NAME', style: 'tableHeader' },
        //                                                 { text: 'DESCRIPTION', style: 'tableHeader' },
        //                                                 { text: 'HSN CODE', style: 'tableHeader' },
        //                                                 { text: 'QTY.', style: 'tableHeader' },
        //                                             ],
        //                                             ...processData.DispatchDetails.map((detail, index) => {
        //                                                 const product = detail.DispatchProductNameData;
        //                                                 const qty = detail.DispatchQty || 0;
        //                                                 return [
        //                                                     { text: (index + 1).toString(), fontSize: 11 },
        //                                                     { text: product?.productName || 'N/A', fontSize: 11 },
        //                                                     { text: detail.DispatchDiscription || 'N/A', fontSize: 11 },
        //                                                     { text: product?.HSNcode || 'N/A', fontSize: 11 },
        //                                                     { text: qty.toString() || 'N/A', fontSize: 11 },
        //                                                 ];
        //                                             })
        //                                         ]
        //                                     },
        //                                     margin: [0, 15, 0, 0]
        //                                 });

        //                                 return (
        //                                     <Box key={processIndex}>
        //                                         <Typography variant="h5" sx={{ marginBottom: 2 }}>
        //                                             Bulk Dispatch Details for {processData.generatedNumber}
        //                                         </Typography>
        //                                     </Box>
        //                                 );
        //                             })}
        //                         </Box>
        //                     );
        //                 })
        //             ) : (
        //                 <Typography variant="h6" color="textSecondary" align="center">
        //                     No Bulk Dispatch Data Available.
        //                 </Typography>
        //             )
        //         }
        //         allPagesContent.push({
        //             text: 'Company Stamp & Sign',
        //             alignment: 'right',
        //             margin: [0, 80, 0, 0]
        //         });
        //     }
        // }
        const docDefinition = {
            content: allPagesContent,
            styles: {
                header: {
                    fontSize: 25,
                    bold: true,
                    color: '#1F2F58',
                    font: 'Lexend',
                },
                subheader: {
                    fontSize: 20,
                    bold: true,
                    margin: [0, 10, 0, 5],
                    font: 'Lexend',
                },
                tableHeader: {
                    bold: true,
                    color: 'white',
                    fillColor: '#293754',
                    font: 'Lexend',
                }
            },
            defaultStyle: {
                fontSize: 12,
                font: 'Lexend',
            }
        };


        return docDefinition;
    };

    const downloadPDF = async () => {


        if (selectedprocess.length > 0) {
            const allContent = [];

            for (const process of selectedprocess) {
                const marketData = Market.find(m => m._id === process.marketId);
                const fData = await processAllDispatchDetails(process);




                const docDefinition = await generatePdfContent(marketData, fData);
                allContent.push(...docDefinition.content);

                if (process !== selectedprocess[selectedprocess.length - 1]) {
                    allContent.push({ text: '', pageBreak: 'before' });
                }
            }




            const finalDocDefinition = {
                content: allContent,
                defaultStyle: {
                    font: 'Lexend',
                },
                styles: {
                    header: {
                        fontSize: 25,
                        bold: true,
                        color: '#1F2F58'
                    },
                    sectionHeader: {
                        fontSize: 16,
                        bold: true,
                        color: 'white',
                        fillColor: '#293754',
                        padding: 8
                    },
                    tableHeader: {
                        bold: true,
                        color: 'white',
                        fillColor: '#293754'
                    }
                },
                defaultStyle: {
                    fontSize: 12
                }
            };
            pdfMake.createPdf(finalDocDefinition).download('multiple_dispatch_challans.pdf');
        } else {

            const matchingDispatchProcess = AlldispatchProcess;



            const fData = await processAllDispatchDetails(matchingDispatchProcess.ProcessData);


            const docDefinition = await generatePdfContent(selectedprocess, { ...matchingDispatchProcess, ProcessData: fData });




            pdfMake.createPdf(docDefinition).download('dispatch_challan.pdf');
        }
    };




    const MemoizedTableRow = React.memo(({ detail, processIndex, index, i, d, isKit, kitData }) => {

        return (
            <TableRow key={index}>
                <TableCell>{index + 1} .</TableCell>
                <TableCell sx={{ width: '8px' }}>
                    <TextField
                        margin="dense"
                        select
                        sx={{
                            width: {
                                xs: "160px",
                                sm: "180px",
                                md: "230px",
                            },
                            height: '40px',
                            "& .MuiInputBase-root": {

                                fontSize: "0.8rem",
                                height: "40px",
                            },
                            "& .MuiInputBase-input": {
                                padding: "0 12px",
                                height: "40px",
                                lineHeight: "40px",
                            },
                        }}
                        variant="filled"
                        onBlur={handleBlur}
                        disabled={d}
                        name={`ProcessData[${i}].DispatchDetails[${index}].DispatchCatogory`}
                        // value={detail.DispatchCatogory || ''}
                        value={
                            isKit
                                ? kitCategoryId // Use kitCategoryId if it's a kit
                                : detail.DispatchCatogory || ''
                        }
                        onChange={(e) => {
                            const newValue = e.target.value;
                            if (values?.ProcessData[i]?.DispatchDetails[index]) {
                                setDispatchDetails(prevDetails => {
                                    const updatedDetails = [...prevDetails];
                                    updatedDetails[i] = { ...updatedDetails[i], DispatchCatogory: newValue };
                                    return updatedDetails;
                                });
                                setFieldValue(`ProcessData[${i}].DispatchDetails[${index}].DispatchCatogory`, newValue);
                                setFieldValue(`ProcessData[${i}].DispatchDetails[${index}].DispatchSubCatogory`, '');
                                setFieldValue(`ProcessData[${i}].DispatchDetails[${index}].DispatchProductName`, '');
                            }
                        }}
                        error={touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchCatogory && Boolean(errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchCatogory)}
                        helperText={touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchCatogory && errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchCatogory}
                        InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                    >
                        {
                            isKit ? (
                                <MenuItem value={kitCategoryId}>
                                    {categories.find(cat => cat._id === kitCategoryId)?.categoryName}
                                </MenuItem>
                            ) :
                                categories?.map((category) => {
                                    const isDisabled = AlldispatchProcess?.ProcessData?.some((v) =>
                                        v?.DispatchDetails.some((v1) =>
                                            (v1.DispatchCatogory === Market?.inverterData?.[0]?.mainCategory && category._id === Market?.inverterData?.[0]?.mainCategory && Market?.MarketingType !== 'Commercial') ||
                                            (v1.DispatchCatogory === Market?.productData?.[0]?.mainCategory && category._id === Market?.productData?.[0]?.mainCategory)
                                        )
                                    );

                                    let sum = 0;

                                    AlldispatchProcess?.ProcessData?.map((v) => {

                                        if (v?.PurposeofDispatch === 'Customer Material') {
                                            let x = v.DispatchDetails?.find(vc => vc?.DispatchCatogory === Market?.productData[0]?.mainCategory);



                                            if (x) {
                                                sum = sum + parseInt(x?.DispatchQty)
                                            }

                                        }
                                    })






                                    return (
                                        <MenuItem key={category._id} value={category._id} disabled={values.ProcessData[i]?.PurposeofDispatch === 'Return Material' || (sum < parseInt(Market?.SolarModuleNos) && category._id != Market?.inverterData?.[0]?.mainCategory) ? false : isDisabled}>
                                            {category.categoryName}
                                        </MenuItem>
                                    );
                                })}
                    </TextField>
                </TableCell>
                <TableCell sx={{ width: '8px' }}>
                    <TextField
                        disabled={d}
                        margin="dense"
                        // label="Sub Category :"
                        select
                        sx={{
                            width: {
                                xs: "160px",
                                sm: "180px",
                                md: "230px",
                            },
                            height: '40px',
                            "& .MuiInputBase-root": {

                                fontSize: "0.8rem",
                                height: "40px",
                            },
                            "& .MuiInputBase-input": {
                                padding: "0 12px",
                                height: "40px",
                                lineHeight: "40px",
                            },
                        }}
                        variant="filled"
                        onBlur={handleBlur}
                        name={`ProcessData[${i}].DispatchDetails[${index}].DispatchSubCatogory`}
                        // value={detail.DispatchSubCatogory || ''}
                        value={
                            isKit
                                ? kitCategoryId // Use kitCategoryId if it's a kit
                                : detail.DispatchSubCatogory || ''
                        }
                        onChange={(e) => {
                            const newValue = e.target.value;
                            if (values?.ProcessData[i]?.DispatchDetails[index]) {
                                setDispatchDetails(prevDetails => {
                                    const updatedDetails = [...prevDetails];
                                    updatedDetails[i] = { ...updatedDetails[i], DispatchSubCatogory: newValue };
                                    return updatedDetails;
                                });
                                setFieldValue(`ProcessData[${i}].DispatchDetails[${index}].DispatchSubCatogory`, newValue);
                                setFieldValue(`ProcessData[${i}].DispatchDetails[${index}].DispatchProductName`, '');
                            }
                        }}
                        error={touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchSubCatogory && Boolean(errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchSubCatogory)}
                        helperText={touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchSubCatogory && errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchSubCatogory}
                        InputLabelProps={{ style: { color: theme.palette.text.primary } }}
                    >
                        {
                            isKit ? (
                                <MenuItem value={kitCategoryId}>
                                    {subcategories.find(cat => cat._id === kitSubCategoryId)?.subCategoryName}
                                </MenuItem>
                            ) :

                                getFilteredSubcategories(detail.DispatchCatogory).data.map(sub => {
                                    let sum = 0;


                                    const isDisabled = AlldispatchProcess?.ProcessData?.some((v) =>
                                        v?.DispatchDetails.some((v1) =>
                                            (v1.DispatchSubCatogory === Market?.inverterData?.[0]?.subCategory && sub._id === Market?.inverterData?.[0]?.subCategory) ||
                                            (v1.DispatchSubCatogory === Market?.productData?.[0]?.subCategory && sub._id === Market?.productData?.[0]?.subCategory)
                                        )
                                    );




                                    AlldispatchProcess?.ProcessData?.map((v) => {

                                        if (v?.PurposeofDispatch === 'Customer Material') {
                                            let x = v.DispatchDetails?.find(vc => vc?.DispatchCatogory === Market?.productData[0]?.mainCategory);



                                            if (x) {
                                                sum = sum + parseInt(x?.DispatchQty)
                                            }

                                        }
                                    })





                                    return (
                                        <MenuItem key={sub._id} value={sub._id} disabled={values.ProcessData[i]?.PurposeofDispatch === 'Return Material' ? false :
                                            (detail.DispatchCatogory === Market?.productData[0]?.mainCategory &&
                                                sub._id !== Market?.productData[0]?.subCategory) ||  // Restrict to Solar PV Module subcategories
                                            (detail.DispatchCatogory === Market?.inverterData[0]?.mainCategory &&
                                                sub._id !== Market?.inverterData[0]?.subCategory) || // Restrict to Solar Grid Tie Inverter subcategories
                                            (detail.DispatchCatogory !== Market?.productData[0]?.mainCategory &&
                                                detail.DispatchCatogory !== Market?.inverterData[0]?.mainCategory &&
                                                isDisabled)}>
                                            {sub.subCategoryName}
                                        </MenuItem>
                                    )

                                })}
                    </TextField>
                </TableCell>

                {/* Product Name */}
                <TableCell sx={{ width: '10px' }}>
                    {values.ProcessData[i].DispatchDetails[index].DispatchCatogory === kitCategoryId &&
                        values.ProcessData[i].DispatchDetails[index].DispatchSubCatogory === kitSubCategoryId ? (
                        <TextField
                            disabled={d}
                            margin="dense"
                            label="Kit Name :"
                            variant="filled"
                            select
                            fullWidth
                            sx={{
                                width: {
                                    xs: "180px",
                                    sm: "200px",
                                    md: "250px",
                                },
                                height: '40px',
                                "& .MuiInputBase-root": {
                                    fontSize: "0.8rem",
                                    height: "40px",
                                },
                                "& .MuiInputBase-input": {
                                    padding: "0 12px",
                                    height: "40px",
                                    lineHeight: "40px",
                                },
                            }}
                            name={`ProcessData[${i}].DispatchDetails[${index}].DispatchKitId`}
                            onChange={(e) => {
                                const newValue = e.target.value;
                                setFieldValue(`ProcessData[${i}].DispatchDetails[${index}].DispatchKitId`, newValue);
                                setFieldValue(`ProcessData[${i}].DispatchDetails[${index}].DispatchProductName`, newValue);

                                const selectedKit = kitproductdata.find(kit => kit._id === newValue);

                                checkKitAvailability(selectedKit?._id)

                                if (selectedKit) {
                                    selectedKit.KitDetails.forEach((kit, ind) => {
                                        setFieldValue(`ProcessData[${i}].DispatchDetails[${index}].DispatchKitDetails`, selectedKit.KitDetails);


                                    });
                                } else {
                                    // Clear the fields if no kit is selected
                                    setFieldValue(`ProcessData[${i}].DispatchDetails[${index}].DispatchProductName`, '');
                                    setFieldValue(`ProcessData[${i}].DispatchDetails[${index}].DispatchDiscription`, '');
                                    setFieldValue(`ProcessData[${i}].DispatchDetails[${index}].DispatchUnit`, '');
                                    setFieldValue(`ProcessData[${i}].DispatchDetails[${index}].DispatchQty`, '');
                                }
                            }}

                            // value={detail.DispatchKitId || detail.DispatchProductName || ''}
                            value={
                                isKit && d
                                    ? kitData?.KitName // Use kitCategoryId if it's a kit
                                    : detail.DispatchKitId || detail.DispatchProductName || ''
                            }
                            InputLabelProps={{
                                style: {
                                    color: theme.palette.text.primary,
                                },
                            }}
                        >
                            {kitproductdata ? kitproductdata.map(kit => (
                                <MenuItem key={kit._id} value={kit._id}>
                                    {kit.KitName}
                                </MenuItem>
                            )) : null}
                        </TextField>



                    ) : (
                        <TextField
                            disabled={d}
                            margin="dense"
                            // label="Product Name : "
                            variant="filled"
                            sx={{
                                width: {
                                    xs: "180px",
                                    sm: "200px",
                                    md: "250px",
                                },
                                height: '40px',
                                "& .MuiInputBase-root": {
                                    fontSize: "0.8rem",
                                    height: "40px",
                                },
                                "& .MuiInputBase-input": {
                                    padding: "0 12px",
                                    height: "40px",
                                    lineHeight: "40px",
                                },
                            }}
                            select
                            // value={detail.DispatchProductName || ''}
                            value={
                                isKit && d
                                    ? kitData?._id // Use kitCategoryId if it's a kit
                                    : detail.DispatchKitId || detail.DispatchProductName || ''
                            }
                            name={`ProcessData[${i}].DispatchDetails[${index}].DispatchProductName`}

                            fullWidth
                            onBlur={handleBlur}
                            onChange={(e) => {
                                const newValue = e.target.value;
                                if (values?.ProcessData[i]?.DispatchDetails[index]) {
                                    const selectedProduct = products.find(prod => prod._id === newValue);
                                    setDispatchDetails(prevDetails => {
                                        const updatedDetails = [...prevDetails];
                                        updatedDetails[i] = {
                                            ...updatedDetails[i],
                                            DispatchProductName: newValue,
                                            DispatchDiscription: selectedProduct?.Desacription || '',
                                            DispatchUnit: selectedProduct?.unitOfMeasurement || ''
                                        };
                                        return updatedDetails;
                                    });
                                    setFieldValue(`ProcessData[${i}].DispatchDetails[${index}].DispatchProductName`, newValue);
                                    setFieldValue(`ProcessData[${i}].DispatchDetails[${index}].DispatchDiscription`, selectedProduct?.Desacription || '');
                                    setFieldValue(`ProcessData[${i}].DispatchDetails[${index}].DispatchUnit`, selectedProduct?.unitOfMeasurement || '');

                                }
                            }}
                            error={touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchProductName && Boolean(errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchProductName)}
                            helperText={touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchProductName && errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchProductName}
                            InputLabelProps={{
                                style: {
                                    color: theme.palette.text.primary
                                }
                            }}
                        >
                            {
                                isKit && d ? (
                                    <MenuItem value={kitData?._id}>
                                        {kitData?.KitName}
                                    </MenuItem>
                                ) :

                                    getFilteredProducts(detail.DispatchCatogory, detail.DispatchSubCatogory)?.data?.map(prod => {


                                        let sum = 0;
                                        let isDisabled;




                                        if (AlldispatchProcess) {


                                            isDisabled = AlldispatchProcess?.ProcessData?.some((v) =>
                                                v?.DispatchDetails.some((v1) =>
                                                    (v1.DispatchProductName === Market?.inverterData[0]?._id
                                                        && prod._id === Market?.inverterData[0]?._id
                                                    ) ||
                                                    (v1.DispatchProductName === Market?.productData[0]?._id
                                                        && prod._id === Market?.productData[0]?._id
                                                    )
                                                )
                                            );


                                        } else if (prod?._id === Market?.productData[0]?._id || prod?._id === Market?.inverterData[0]?._id) {

                                            isDisabled = false
                                        } else {
                                            if (prod.mainCategory === "6749c8c7864db29472435057" || prod.mainCategory === '6749c8bf864db29472435052') {
                                                isDisabled = true
                                            } else {
                                                isDisabled = false
                                            }


                                        }





                                        AlldispatchProcess?.ProcessData?.map((v) => {

                                            if (v?.PurposeofDispatch === 'Customer Material') {
                                                let x = v.DispatchDetails?.find(vc => vc?.DispatchCatogory === Market?.productData[0]?.mainCategory);



                                                if (x) {
                                                    sum = sum + parseInt(x?.DispatchQty)
                                                }

                                            }
                                        })




                                        return (
                                            <MenuItem
                                                key={prod._id}
                                                value={prod._id}
                                                disabled={
                                                    // Always enabled for Return Material
                                                    values.ProcessData[i]?.PurposeofDispatch === 'Return Material' ||
                                                        (detail.DispatchCatogory === Market?.productData[0]?.mainCategory &&
                                                            (sum <= parseInt(Market?.SolarModuleNos) && prod._id === Market?.productData[0]?._id))
                                                        ? false
                                                        : // For Customer Material, apply these checks:
                                                        (
                                                            // Check if product doesn't match selected category/subcategory
                                                            prod.mainCategory !== detail.DispatchCatogory ||
                                                            prod.subCategory !== detail.DispatchSubCatogory ||

                                                            // If PV/Inverter category, only allow Market's specific product
                                                            (detail.DispatchCatogory === Market?.productData[0]?.mainCategory &&
                                                                prod._id !== Market?.productData[0]?._id) ||
                                                            (detail.DispatchCatogory === Market?.inverterData[0]?.mainCategory &&
                                                                prod._id !== Market?.inverterData[0]?._id)

                                                            // Check if product was already dispatched
                                                            // AlldispatchProcess?.ProcessData?.some((v) =>
                                                            //     v?.DispatchDetails.some(v1 =>
                                                            //         v1.DispatchProductName === prod._id
                                                            //     )
                                                            // )
                                                        )
                                                }
                                            >
                                                {prod.productName}
                                            </MenuItem>
                                        )
                                    })
                            }
                        </TextField>
                    )}
                </TableCell>
                <TableCell sx={{ width: '10px' }}>
                    {
                        values.ProcessData[i].DispatchDetails[index].DispatchCatogory === kitCategoryId &&
                            values.ProcessData[i].DispatchDetails[index].DispatchSubCatogory === kitSubCategoryId ? (
                            ''
                        ) : d && isKit ? ''
                            : (
                                <TextField
                                    disabled={d}
                                    margin="dense"
                                    // label="Description : "
                                    sx={{
                                        width: {
                                            xs: "180px",
                                            sm: "200px",
                                            md: "250px",
                                        },
                                        height: '40px',
                                        "& .MuiInputBase-root": {
                                            fontSize: "0.8rem",
                                            height: "40px",
                                        },
                                        "& .MuiInputBase-input": {
                                            padding: "0 12px",
                                            height: "40px",
                                            lineHeight: "40px",
                                        },
                                    }}
                                    variant="filled"
                                    fullWidth
                                    value={products?.find(prod => prod._id === detail.DispatchProductName)?.Desacription || ''}
                                    InputLabelProps={{
                                        shrink: true,
                                        style: {
                                            color: theme.palette.text.primary
                                        }
                                    }}
                                />
                            )}
                </TableCell>
                <TableCell sx={{ width: '10px' }}>
                    {values.ProcessData[i].DispatchDetails[index].DispatchCatogory === kitCategoryId &&
                        values.ProcessData[i].DispatchDetails[index].DispatchSubCatogory === kitSubCategoryId ? (
                        ''
                    ) : d && isKit ? ''
                        : (
                            <TextField
                                disabled={d}
                                margin="dense"
                                // label="Unit : "
                                variant="filled"
                                fullWidth
                                sx={{
                                    width: {
                                        xs: "80px",
                                        sm: "80px",
                                        md: "80px",
                                    },
                                    height: '40px',
                                    "& .MuiInputBase-root": {
                                        fontSize: "0.8rem",
                                        height: "40px",
                                    },
                                    "& .MuiInputBase-input": {
                                        padding: "0 12px",
                                        height: "40px",
                                        lineHeight: "40px",
                                    },
                                }}
                                value={products?.find(prod => prod._id === detail.DispatchProductName)?.unitOfMeasurement || ''}
                                InputLabelProps={{
                                    shrink: true,
                                    style: {
                                        color: theme.palette.text.primary
                                    }
                                }}
                            />
                        )}
                </TableCell>
                <TableCell sx={{ width: '10px', paddingTop: '30px' }}>
                    {values.ProcessData[i].DispatchDetails[index].DispatchCatogory === kitCategoryId &&
                        values.ProcessData[i].DispatchDetails[index].DispatchSubCatogory === kitSubCategoryId ? (
                        <>
                            {kitAvaStatus?.Status}
                        </>
                    ) : d && isKit ? '1'
                        : (
                            // <TextField
                            //     disabled={d}
                            //     margin="dense"
                            //     // label="Quantity : "
                            //     variant="filled"
                            //     fullWidth
                            //     value={detail.DispatchQty}
                            //     name={`ProcessData[${i}].DispatchDetails[${index}].DispatchQty`}
                            //     InputLabelProps={{
                            //         shrink: true,
                            //         style: {
                            //             color: theme.palette.text.primary
                            //         }
                            //     }}
                            //     sx={{
                            //         width: {
                            //             xs: "100px",
                            //             sm: "100px",
                            //             md: "100px",
                            //         },
                            //         height: '40px',
                            //         "& .MuiInputBase-root": {
                            //             fontSize: "0.8rem",
                            //             height: "40px",
                            //         },
                            //         "& .MuiInputBase-input": {
                            //             padding: "0 12px",
                            //             height: "40px",
                            //             lineHeight: "40px",
                            //         },
                            //     }}
                            //     onBlur={handleBlur}
                            //     onChange={(e) => {
                            //         const updatedDetails = values?.ProcessData[i]?.DispatchDetails.map((d, idx) => {
                            //             if (idx === index) {
                            //                 return { ...d, DispatchQty: e.target.value };
                            //             }
                            //             return { ...d };
                            //         });
                            //         setDispatchDetails(prevDetails => {
                            //             const newDetails = [...prevDetails];
                            //             newDetails[i] = updatedDetails;
                            //             return newDetails;
                            //         });
                            //         setFieldValue(`ProcessData[${i}].DispatchDetails[${index}].DispatchQty`, e.target.value);
                            //     }}
                            //     error={touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchQty && Boolean(errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchQty)}
                            //     helperText={touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchQty && errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchQty}
                            // />
                            <QtyInput
                                i={i}
                                index={index}
                                value={formik.values.ProcessData[i].DispatchDetails[index].DispatchQty}
                                name={`ProcessData[${i}].DispatchDetails[${index}].DispatchQty`}
                                setFieldValue={formik.setFieldValue}
                                handleBlur={formik.handleBlur}
                                error={
                                    formik.touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchQty &&
                                    Boolean(formik.errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchQty)
                                }
                                helperText={
                                    formik.touched.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchQty &&
                                    formik.errors.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchQty
                                }
                                isSubmitting={formik.isSubmitting}
                                disabled={d}
                                theme={theme}
                            />

                        )}
                    {values.ProcessData[i].DispatchDetails[index].DispatchCatogory === kitCategoryId &&
                        values.ProcessData[i].DispatchDetails[index].DispatchSubCatogory === kitSubCategoryId ? '' :
                        d ? '' :
                            <Typography variant="body2" color="textSecondary">
                                Available Qty: {getAvailableQty(Market?.wareHouseData[0]?._id, values.ProcessData?.[i]?.DispatchDetails?.[index]?.DispatchProductName)}
                            </Typography>}
                </TableCell>
                <TableCell>
                    <Stack spacing={2} direction="row">
                        <Button
                            disabled={d}
                            variant="contained"
                            color="success"
                            onClick={() => handleAddKit1(i, index)}
                            sx={{
                                width: "35px",
                                height: "35px",
                                minWidth: "20px",
                                padding: "0",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            }}
                        >
                            <AddIcon sx={{ fontSize: "16px" }} />
                        </Button>
                        {(!AlldispatchProcess?.ProcessData?.some(process => process.DispatchDetails.includes(detail))) && (
                            <Button
                                variant="contained"
                                color="error"
                                onClick={() => handleOpenDeleteDialog(i, index)}
                                sx={{
                                    width: "35px",
                                    height: "35px",
                                    minWidth: "20px",
                                    padding: "0",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <DeleteIcon sx={{ fontSize: "16px" }} />
                            </Button>
                        )}
                    </Stack>
                </TableCell>
            </TableRow>
        );
    });




    return (
        <Box m="2px" sx={{ marginTop: 0 }}>
            <form onSubmit={handleSubmit} enctype="multipart/form-data">
                <Stack sx={{ width: '100%' }}>
                    <Box sx={{ position: 'sticky', top: -20, background: theme.palette.background.default, zIndex: 10, padding: '20px', overflowX: 'auto' }}>
                        {id ? (
                            <Header
                                title="UPDATE DISPATCH PROCESS"
                                subtitle="Update Your Dispatch Process Here"
                            />
                        ) : (
                            <Header
                                title="ADD DISPATCH PROCESS"
                                subtitle="Manage Your Dispatch Process Here"
                            />
                        )}
                        <div style={{ display: 'flex', color: theme.palette.text.primary, whiteSpace: 'nowrap' }}>
                            <ul style={{ listStyle: 'none', padding: 0 }}>
                                <li>File No</li>
                                <li>Customer Name</li>
                                <li>System Size </li>
                                <li>Address </li>
                                <li>City </li>
                                <li>Dealer Name </li>
                            </ul>
                            <ul style={{ listStyle: 'none' }}>
                                <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{Market?.fillNo}</li>
                                <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{Market?.ConsumerName}</li>
                                <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{Market?.SystemSizeKw}</li>
                                <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{Market?.Address}</li>
                                <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{Market?.City_Village}</li>
                                <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{Market?.userData?.[0].name}</li>
                            </ul>
                            <ul style={{ listStyle: 'none' }}>
                                <li>Customer Pending Payment </li>
                                <li>Marketing Warehouse Name</li>
                                <li>Date of Dispatch</li>
                                <li>Solar PV</li>
                                <li>Solar Inverter </li>
                            </ul>
                            <ul style={{ listStyle: 'none' }}>
                                <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    {(() => {
                                        if (!Market?.AccountData || Market?.AccountData?.length === 0) {
                                            return 'No Account Data Available';
                                        }

                                        const accountDetails = Market.AccountData[0]?.AccountDetails || [];
                                        const totalAccountAmount = accountDetails.reduce(
                                            (sum, account) => sum + parseFloat(account.AccountAmount || 0),
                                            0
                                        );

                                        const remainingAmount = parseFloat(Market.TotalAmount || 0) - totalAccountAmount;

                                        return remainingAmount > 0
                                            ? `${remainingAmount}`
                                            : 'Fully Paid';
                                    })()}
                                </li>
                                <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{Market?.wareHouseData[0]?.wareHouseName}</li>
                                <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    {AlldispatchProcess?.ProcessData
                                        ?.map(data => format(new Date(data.DispatchDate), 'dd-MM-yyyy')).join(', ') || 'N/A'}
                                </li>
                                <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{Market?.productData?.[0].productName} ({Market?.SolarModuleNos})</li>
                                <li>: &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{Market?.inverterData?.[0].productName}</li>
                            </ul>
                        </div>
                    </Box>
                    <Box sx={{ overflowY: 'auto', flex: 1, padding: '20px', position: "relative" }}>
                        {values.ProcessData?.length === 0 && handleAddProcess()}
                        {values.ProcessData?.map((process, i) => {
                            const currentReturnCount = values?.ProcessData?.slice(0, i + 1).filter(p => p?.PurposeofDispatch === "Return Material")?.length;
                            const currentDispatchCount = values?.ProcessData?.slice(0, i + 1).filter(p => p?.PurposeofDispatch === "Customer Material")?.length;
                            // let d = AlldispatchProcess?.ProcessData?.some(p => values.ProcessData.some(s => s?.generatedNumberprocess === p.generatedNumberprocess));


                            return (
                                <>
                                    <Box
                                        key={i}
                                        display="grid"
                                        gap="30px"
                                        gridTemplateColumns="repeat(4, minmax(0, 1fr))"
                                        sx={{
                                            "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                                            mb: 2
                                        }}>
                                        <div style={{ color: theme.palette.text.primary, fontSize: '18px', display: 'flex', flexWrap: 'nowrap', alignItems: 'center', justifyContent: 'center' }}>
                                            {process?.PurposeofDispatch === "Return Material"
                                                ? (currentReturnCount > 0 ? `Return ${currentReturnCount}` : '')
                                                : (currentDispatchCount > 0 ? `Dispatch ${currentDispatchCount}` : '')}
                                        </div>
                                        <TextField
                                            disabled={process?.generatedNumber}
                                            margin="dense"
                                            label="Date : "
                                            variant="filled"
                                            type="date"
                                            fullWidth
                                            value={process.DispatchDate}
                                            name={`ProcessData[${i}].DispatchDate`}
                                            onChange={(e) => handleDispatchDetailChange(i, 'DispatchDate', e.target.value)}
                                            InputLabelProps={{
                                                shrink: true,
                                                style: {
                                                    color: theme.palette.text.primary
                                                }
                                            }}
                                            onBlur={handleBlur}
                                            error={touched.ProcessData?.[i]?.DispatchDate && Boolean(errors.ProcessData?.[i]?.DispatchDate)}
                                            helperText={touched.ProcessData?.[i]?.DispatchDate && errors.ProcessData?.[i]?.DispatchDate}
                                        />
                                        <TextField
                                            disabled={process?.generatedNumber}
                                            margin="dense"
                                            label="Purpose of Dispatch :"
                                            variant="filled"
                                            select
                                            name={`ProcessData[${i}].PurposeofDispatch`}
                                            value={process?.PurposeofDispatch || "Customer Material"}
                                            onBlur={handleBlur}
                                            fullWidth
                                            onChange={(e) => {
                                                const newValue = e.target.value;

                                                // Reset the category and dependent fields when PurposeofDispatch changes
                                                const updatedProcesses = values?.ProcessData?.map((p, idx) => {
                                                    if (idx === i) {
                                                        return {
                                                            ...p,
                                                            PurposeofDispatch: newValue,
                                                            DispatchDetails: p?.DispatchDetails?.map(detail => ({
                                                                ...detail,
                                                                DispatchCatogory: "",  // Reset category
                                                                DispatchSubCatogory: "",  // Reset sub-category
                                                                DispatchProductName: "",  // Reset product name
                                                                DispatchDiscription: "",
                                                                DispatchQty: '',
                                                                DispatchUnit: ''
                                                            })),
                                                        };
                                                    }
                                                    return p;
                                                });

                                                setFieldValue("ProcessData", updatedProcesses);
                                            }}
                                            error={touched.ProcessData?.[i]?.PurposeofDispatch && Boolean(errors.ProcessData?.[i]?.PurposeofDispatch)}
                                            helperText={touched.ProcessData?.[i]?.PurposeofDispatch && errors.ProcessData?.[i]?.PurposeofDispatch}
                                            InputLabelProps={{
                                                style: {
                                                    color: theme.palette.text.primary
                                                }
                                            }}
                                        >
                                            <MenuItem value="Customer Material">Customer Material</MenuItem>
                                            <MenuItem value="Return Material">Return Material</MenuItem>
                                        </TextField>
                                        {process?.PurposeofDispatch === "Customer Material" && (
                                            <TextField
                                                disabled={process?.generatedNumber}
                                                margin="dense"
                                                label="Dispatch Suggestion :"
                                                variant="filled"
                                                select
                                                fullWidth
                                                name={`ProcessData[${i}].DispatchSuggestionId`}
                                                onChange={(e) => handleDispatchSuggestion(e, i)}
                                                value={process.DispatchSuggestionId || ''}
                                                InputLabelProps={{
                                                    style: {
                                                        color: theme.palette.text.primary
                                                    }
                                                }}
                                            >
                                                {suggestiondata?.map((suggestion) => (
                                                    <MenuItem key={suggestion._id} value={suggestion._id}>
                                                        {suggestion.ProjectName}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        )}
                                    </Box>

                                    <Box sx={{ overflowX: "auto", width: "100%" }}>
                                        <TableContainer>
                                            <Table>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell sx={{ width: "70px", fontSize: "14px" }}> Sr No</TableCell>
                                                        <TableCell sx={{ fontSize: "14px" }}>Category</TableCell>
                                                        <TableCell sx={{ fontSize: "14px" }}>Sub Category</TableCell>
                                                        <TableCell sx={{ fontSize: "14px" }}>Product Name</TableCell>
                                                        <TableCell sx={{ fontSize: "14px" }}>Description</TableCell>
                                                        <TableCell sx={{ fontSize: "14px" }}>Unit of Measurement</TableCell>
                                                        <TableCell sx={{ fontSize: "14px" }}>Quantity</TableCell>
                                                        <TableCell sx={{ fontSize: "14px" }}>Action</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {values.ProcessData[i].DispatchDetails?.reduce((acc, detail) => {


                                                        const kitNo = detail.KitNo;


                                                        // Check if this KitNo already exists in the accumulator
                                                        if (!acc.find(item => item.KitNo === kitNo && kitNo > 0)) {
                                                            acc.push(detail); // Only add unique KitNo entries
                                                        }
                                                        return acc;
                                                    }, []).map((detail, index) => {
                                                        // Now map through the unique entries
                                                        let d = AlldispatchProcess?.ProcessData?.some(process =>
                                                            process.DispatchDetails.includes(detail)
                                                        );

                                                        const isKit = detail.DispatchKitId; // Check if this is a kit
                                                        const kitData = isKit ? kitproductdata.find(kit => kit._id === detail.DispatchKitId) : null;

                                                        let kname = isKit ? categories.find(cat => cat._id === kitCategoryId)?.categoryName
                                                            : null;




                                                        return (
                                                            <MemoizedTableRow
                                                                key={detail.id || index}
                                                                detail={detail}
                                                                i={i}
                                                                d={d}
                                                                index={index}
                                                                isKit={isKit}
                                                                kitData={kitData}
                                                            />
                                                        )

                                                    })}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Box>

                                    <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
                                        <DialogTitle>Confirm Deletion</DialogTitle>
                                        <DialogContent>
                                            Are you sure you want to delete this item?
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={handleCloseDeleteDialog} sx={{ color: theme.palette.text.primary }}>
                                                Cancel
                                            </Button>
                                            <Button onClick={handleDeleteConfirmed} color="error">
                                                Delete
                                            </Button>
                                        </DialogActions>
                                    </Dialog>

                                    <Dialog open={open} onClose={handleClose}>
                                        <DialogTitle>{id ? 'Edit Dispatch Process' : 'Add Dispatch Process'}</DialogTitle>
                                        <DialogContent>
                                            <Box
                                                key={i}
                                                display="grid"
                                                gap="30px"
                                                gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                                                sx={{
                                                    "& > div": { gridColumn: isNonMobile ? undefined : "span 2" },
                                                    marginBottom: '20px',
                                                }}
                                            >
                                                <TextField
                                                    margin="dense"
                                                    label={process.PurposeofDispatch === "Return Material" ? "Credit Warehouse Name :" : "Debit Warehouse Name :"}
                                                    variant="filled"
                                                    select
                                                    fullWidth
                                                    value={Market?.wareHouseData[0]?._id || ''}
                                                    // onChange={(e) => handleProcessChange(i, 'DebitCreditWarehouseName', e.target.value)}
                                                    InputLabelProps={{
                                                        style: {
                                                            color: theme.palette.text.primary
                                                        }
                                                    }}
                                                    name={`ProcessData[${i}].DebitCreditWarehouseName`}
                                                    onBlur={handleBlur}
                                                    error={touched.ProcessData?.[i]?.DebitCreditWarehouseName && Boolean(errors.ProcessData?.[i]?.DebitCreditWarehouseName)}
                                                    helperText={touched.ProcessData?.[i]?.DebitCreditWarehouseName && errors.ProcessData?.[i]?.DebitCreditWarehouseName}
                                                    sx={{ display: 'none' }}
                                                >
                                                    {/* {warehousedata?.map((warehouse) => (
                                                        <MenuItem key={warehouse._id} value={warehouse._id}>
                                                            {warehouse.wareHouseName}
                                                        </MenuItem>
                                                    ))} */}
                                                </TextField>
                                                <TextField
                                                    margin="dense"
                                                    label="Mode Of Transport : "
                                                    variant="filled"
                                                    fullWidth
                                                    name={`ProcessData[${i}].DispatchModelTransport`}
                                                    onBlur={handleBlur}
                                                    value={process.DispatchModelTransport}
                                                    onChange={(e) => handleProcessChange(i, 'DispatchModelTransport', e.target.value)}
                                                    InputLabelProps={{
                                                        style: {
                                                            color: theme.palette.text.primary
                                                        }
                                                    }}
                                                    error={touched.ProcessData?.[i]?.DispatchModelTransport && Boolean(errors.ProcessData?.[i]?.DispatchModelTransport)}
                                                    helperText={touched.ProcessData?.[i]?.DispatchModelTransport && errors.ProcessData?.[i]?.DispatchModelTransport}
                                                />
                                                <TextField
                                                    margin="dense"
                                                    label="Remarks : "
                                                    variant="filled"
                                                    fullWidth
                                                    name={`ProcessData[${i}].DispatchRemarks`}
                                                    error={touched.ProcessData?.[i]?.DispatchRemarks && Boolean(errors.ProcessData?.[i]?.DispatchRemarks)}
                                                    helperText={touched.ProcessData?.[i]?.DispatchRemarks && errors.ProcessData?.[i]?.DispatchRemarks}
                                                    onBlur={handleBlur}
                                                    value={process.DispatchRemarks}
                                                    onChange={(e) => handleProcessChange(i, 'DispatchRemarks', e.target.value)}
                                                    InputLabelProps={{
                                                        style: {
                                                            color: theme.palette.text.primary
                                                        }
                                                    }}
                                                />
                                            </Box>
                                        </DialogContent>
                                        <DialogActions>
                                            <Button onClick={handleClose} style={{ color: theme.palette.text.primary }}>Cancel</Button>
                                            <Button
                                                onClick={handleSubmit}
                                                disabled={insufficientProducts.size > 0 ? true : false}
                                            >
                                                {id ? 'Update' : 'Submit'}
                                            </Button>


                                        </DialogActions>
                                    </Dialog>
                                    <Box display="flex" justifyContent="flex-end" m={1}>
                                        <Button
                                            disabled={i < AlldispatchProcess?.ProcessData?.length ? true : false}
                                            variant="contained"
                                            color="primary"
                                            startIcon={<AddIcon />}
                                            onClick={() => { handleAddDispatchDetail(i) }}
                                        >
                                            Add Dispatch Detail
                                        </Button>
                                    </Box>
                                    <IconButton aria-label="print" style={{ backgroundColor: '#141b2d' }} sx={{ mr: 2, bgcolor: '#141b2d', color: "white", padding: "10px" }}
                                        onClick={() => handlePrint(AlldispatchProcess, process, i)}
                                    >
                                        <PrintIcon />
                                    </IconButton>
                                </>
                            )
                        })}
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcon />}
                            onClick={handleAddProcess}
                        >
                            Add Process
                        </Button>
                    </Box>
                    <FormControl>
                        <Stack direction="row" spacing={2} sx={{ m: 1, minWidth: 120 }}>

                            <Button
                                variant="contained"
                                onClick={handleOpen}
                                disabled={insufficientProducts.size > 0 ? true : false}
                            >
                                {id ? 'Update' : 'Save'}
                            </Button>


                        </Stack>
                    </FormControl>
                </Stack>
            </form>

            <Dialog open={openDialog} onClose={handleCloseDialog} fullWidth maxWidth="md">
                <DialogContent>
                    {(() => {
                        if (!selectedprocess?.ProcessData?.length) {
                            return (
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    minHeight: '100px'
                                }}>
                                    <Typography variant="h5" color="textSecondary">
                                        No PDF Available
                                    </Typography>
                                </Box>
                            );
                        }

                        return (
                            <>
                                {processAllDispatchDetails(selectedprocess.ProcessData)?.map((item, index) => (
                                    <Box key={index} sx={{ padding: 2 }} ref={printRef}>
                                        <Grid container justifyContent="space-between" alignItems="center" sx={{ marginBottom: 4 }}>
                                            <Grid item xs={12} sm={6}>
                                                <Box
                                                    component="img"
                                                    className='pdf-logo'
                                                    src={(theme.palette.mode === "dark" ? '../../assets/images/logo/dark-logo.png' : '../../assets/images/logo/logo.svg')}
                                                    alt="Tvarit Energy LLP Logo"
                                                    sx={{ width: { xs: '100%', sm: '150px' }, maxWidth: '150px' }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ textAlign: 'right', marginBottom: 2 }}>
                                                    <Typography
                                                        variant="h5"
                                                        className="process-order-title"
                                                        sx={{
                                                            fontWeight: 'bold',
                                                            fontSize: '25px',
                                                            letterSpacing: '5px',
                                                            color: theme.palette.mode === "dark" ? 'white' : '#1F2F58',
                                                            position: 'relative',
                                                            display: 'inline-block',
                                                            borderBottom: '2px solid #FB9822',
                                                            paddingBottom: '4px'
                                                        }}
                                                    >
                                                        <Typography variant="h5" sx={{ fontSize: window.innerWidth <= 425 ? '22px' : '25px' }}>
                                                            {item?.generatedNumber.includes('Return') ? 'RETURN CHALLAN' : 'DISPATCH CHALLAN'}
                                                        </Typography>
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} sx={{ display: 'flex', alignItems: 'flex-start', height: '100%' }}>
                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ backgroundColor: '#293754', color: 'white', padding: 1 }}>
                                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '16px', letterSpacing: '3px' }}>CUSTOMER DETAILS</Typography>
                                                </Box>
                                                <Grid container direction="column" spacing={1} sx={{ marginTop: '10px' }}>
                                                    <Grid item container>
                                                        <Grid item xs={4}><Typography sx={{ fontWeight: '700' }}>Customer Name</Typography></Grid>
                                                        <Grid item xs={1}><Typography>:</Typography></Grid>
                                                        <Grid item xs={7}><Typography>{selectedprocess?.marketData?.ConsumerName + ' (' + selectedprocess?.marketData?.fillNo + ')' || 'N/A'}</Typography></Grid>
                                                    </Grid>
                                                    <Grid item container>
                                                        <Grid item xs={4}><Typography sx={{ fontWeight: '700' }}>Customer Address</Typography></Grid>
                                                        <Grid item xs={1}><Typography>:</Typography></Grid>
                                                        <Grid item xs={7}><Typography>{selectedprocess?.marketData?.Address || 'N/A'}</Typography></Grid>
                                                    </Grid>
                                                    <Grid item container>
                                                        <Grid item xs={4}><Typography sx={{ fontWeight: '700' }}>Customer Mobile No</Typography></Grid>
                                                        <Grid item xs={1}><Typography>:</Typography></Grid>
                                                        <Grid item xs={7}><Typography>{selectedprocess?.marketData?.PhoneNumber || 'N/A'}</Typography></Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                            <Grid item xs={12} sm={6} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start' }}>
                                                <Grid item container>
                                                    <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Date&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;</Typography></Grid>
                                                    <Grid item xs={8}>
                                                        <Typography sx={{ fontWeight: '600' }}>
                                                            {format(item?.DispatchDate, 'dd-MM-yyyy')}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>

                                                <Grid item container>
                                                    <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Dispatch Number &nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp;</Typography></Grid>
                                                    <Grid item xs={8}>
                                                        <Typography sx={{ fontWeight: '600' }}>
                                                            {item?.generatedNumber || 'N/A'}
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={2} sx={{ marginTop: 2 }}>
                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ backgroundColor: '#293754', color: 'white', padding: 1 }}>
                                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '16px', letterSpacing: '3px' }}>TVARIT ADDRESS</Typography>
                                                </Box>
                                                <Box sx={{ marginTop: '10px', wordSpacing: '2px' }}>
                                                    <Grid container direction="column" spacing={1}>
                                                        <Grid item container>
                                                            <Grid item xs={4}><Typography sx={{ fontWeight: '700' }}>Company Name</Typography></Grid>
                                                            <Grid item xs={1}><Typography sx={{ fontWeight: '700' }}>:</Typography></Grid>
                                                            <Grid item xs={7}><Typography sx={{ fontWeight: '700' }}>{orderDetails.billTo.companyName}</Typography></Grid>
                                                        </Grid>
                                                        <Grid item container>
                                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Address</Typography></Grid>
                                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                                            <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>{orderDetails.billTo.address}</Typography></Grid>
                                                        </Grid>
                                                        <Grid item container>
                                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>GST No</Typography></Grid>
                                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                                            <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>24AAQFT9592E1ZK</Typography></Grid>
                                                        </Grid>
                                                        <Grid item container>
                                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Contact No</Typography></Grid>
                                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                                            <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>+91 97245 71843</Typography></Grid>
                                                        </Grid>
                                                        <Grid item container>
                                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Email</Typography></Grid>
                                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                                            <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>info@tvaritenergy.in</Typography></Grid>
                                                        </Grid>
                                                        <Grid item container>
                                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Website</Typography></Grid>
                                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                                            <Grid item xs={7}><Typography sx={{ fontWeight: '600' }}>www.tvaritenergy.in</Typography></Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </Grid>
                                            <Grid item xs={12} sm={6}>
                                                <Box sx={{ backgroundColor: '#293754', color: 'white', padding: 1 }}>
                                                    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', fontSize: '16px', letterSpacing: '3px' }}>SHIP FROM</Typography>
                                                </Box>
                                                <Box sx={{ marginTop: '10px', wordSpacing: '2px' }} >
                                                    <Grid container direction="column" spacing={1}>
                                                        <Grid item container>
                                                            <Grid item xs={4}><Typography sx={{ fontWeight: '600' }}>Company Name</Typography></Grid>
                                                            <Grid item xs={1}><Typography sx={{ fontWeight: '600' }}>:</Typography></Grid>
                                                            <Grid item xs={7}>
                                                                <Typography sx={{ fontWeight: '600' }}>
                                                                    {(() => {
                                                                        const ProcessWarehouse = selectedprocess;
                                                                        if (!ProcessWarehouse?.ProcessData?.[index]) return 'N/A';

                                                                        const warehouseName = ProcessWarehouse.ProcessData[index]?.DebitCreditWarehouseData?.wareHouseName || 'N/A';

                                                                        return warehouseName;
                                                                    })()}
                                                                </Typography>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Box>
                                            </Grid>
                                        </Grid>

                                        <TableContainer sx={{ marginTop: 2 }}>
                                            <Table>
                                                <TableHead sx={{ backgroundColor: '#293754' }}>
                                                    <TableRow>
                                                        <TableCell sx={{ color: 'white' }}>SR. NO.</TableCell>
                                                        <TableCell sx={{ color: 'white' }}>PRODUCT NAME</TableCell>
                                                        <TableCell sx={{ color: 'white' }}>DESCRIPTION</TableCell>
                                                        <TableCell sx={{ color: 'white' }}>HSN CODE</TableCell>
                                                        <TableCell sx={{ color: 'white' }}>QTY.</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {(() => {

                                                        return item.DispatchDetails
                                                            ?.map((item, DataIndex) => {

                                                                const productName = item?.KitNo === 0 ?
                                                                    item.DispatchProductNameData || 'N/A' :
                                                                    kitproductdata?.find((k) => k?._id === item.DispatchKitId)
                                                                    ;

                                                                return (
                                                                    <TableRow key={DataIndex}>
                                                                        <TableCell sx={{ fontWeight: '600' }}>{DataIndex + 1}</TableCell>
                                                                        <TableCell sx={{ fontWeight: '600' }}>{productName?.productName || productName?.KitName}</TableCell>
                                                                        <TableCell sx={{ fontWeight: '600' }}>{item?.KitNo === 0 ? item.DispatchDiscription : 'N/A'}</TableCell>
                                                                        <TableCell sx={{ fontWeight: '600' }}>{productName?.HSNcode || 'N/A'}</TableCell>
                                                                        <TableCell sx={{ fontWeight: '600' }}>{item?.KitNo === 0 ? item.DispatchQty : 1}</TableCell>

                                                                    </TableRow>
                                                                );
                                                            }) || [];
                                                    })()}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                        <Grid container justifyContent="flex-end" sx={{ marginTop: -2 }}>
                                            <Grid item>
                                                <Box
                                                    component="img"
                                                    className='stamp-sign'
                                                    src={'../../assets/images/stamp/stamp-1.svg'}
                                                    alt="Tvarit Energy LLP stamp"
                                                    sx={{ width: 150 }}
                                                />
                                                <Typography variant="body1" sx={{ fontWeight: '600' }}>Company Stamp & Sign</Typography>
                                            </Grid>
                                        </Grid>
                                    </Box>
                                ))}
                            </>
                        );
                    })()}
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={downloadPDF}
                        sx={{ color: theme.palette.text.primary }}
                    // disabled={!AlldispatchProcess?.find(process => process.marketId === selectedprocess?._id)?.ProcessData?.length}
                    >
                        Download PDF
                    </Button>
                    <Button onClick={handleCloseDialog} sx={{ color: theme.palette.text.primary }}>Close</Button>
                </DialogActions>
            </Dialog>


        </Box >
    )
}

export default AddDispatchProcess


